<div class="grid-wrapper">
  <app-grid-wrapper-header
    [gridOptions]="gridOptions"
    [columnDefs]="columnDefs"
    [page]="page"
    [bulkType]="bulkType"
    [hasSidebar]="gridOptions.sideBar ? true : false"
    [showActions]="showActions"
    [actions]="actions"
    (dateFilterOutput)="setDateFilter($event)"
    [defaultDateFilter]="defaultDateFilter"
    (accountFilterType)="setAccountFilter($event)"
    (groupByList)="groupByListFilter($event)"
    [hideSearch]="hideSearch"
    (dateChange)="setDateByDefault($event)"
    [datePickerLabel]="datePickerLabel"
    (multipleDateFilter) = "setmultipleDateFilter($event)"
    (groupSkuList)="groupSkuList($event)"
    (groupBySettlementList)="groupBySettlementListFilter($event)"
    (viewByPlList)="groupByPlFilter($event)"
    (selectedDateRange)="setDateRange($event)"
    (groupBysalesTrendList)="groupBysalesFilter($event)"
    (groupByDefaultList)="groupByDefaultList($event)"
    (selectedWarehouse)="setWarehouse($event)"
  ></app-grid-wrapper-header>

  <div class="grid-wrapper_grid">
    <ag-grid-angular 
      style="width: 100%; height: 100%" 
      class="ag-theme-alpine"
      [gridOptions]="gridOptions"
      [columnDefs]="columnDefs" 
      [modules]="modules"
      [overlayNoRowsTemplate]="overlayNoRowsTemplate"
      [detailCellRendererParams]="detailCellRendererParams"
      [masterDetail]="masterDetail"
      [defaultColDef]="defaultColDef"
      [detailRowAutoHeight]="detailRowAutoHeight">
    </ag-grid-angular>
  </div>
</div>